import { Box } from '@chakra-ui/react';

import Tooltip from 'UiKit/tooltip';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ProductCodeColumn = ({ values }) => {
  const { skuCode, erpCode, magpieCode } = values;
  return (
    <Box className={styles['product-code-column__container']}>
      <TextRegular className={styles['product-code__label']}>SKU </TextRegular>
      <Tooltip className={styles['product-code__tooltip']} label={skuCode}>
        <TextRegular className={styles['product-code__value']}>{skuCode}</TextRegular>
      </Tooltip>
      <TextRegular className={styles['product-code__label']}>ERP Code</TextRegular>
      <Tooltip className={styles['product-code__tooltip']} label={erpCode}>
        <TextRegular className={styles['product-code__value']}>{erpCode}</TextRegular>
      </Tooltip>
      <TextRegular className={styles['product-code__label']}>Magpie Code</TextRegular>
      <Tooltip className={styles['product-code__tooltip']} label={magpieCode}>
        <TextRegular className={styles['product-code__value']}>{magpieCode}</TextRegular>
      </Tooltip>
    </Box>
  );
};

export default ProductCodeColumn;
